//import translations from '../../../../data/translations';
import Vue from 'vue';
import enLocale from 'element-ui/lib/locale/lang/en';
import deLocale from 'element-ui/lib/locale/lang/de';
import locale from 'element-ui/lib/locale';
import defaultTranslations from '../../data/defaultTranslations'

const state = {
   translations: {},
   selectedLanguage: 'de',
   defaultTranslations: defaultTranslations
};

const mutations = {
   'SET_LANGUAGE': (state, lang) => {
      if(!lang || lang == 'undefined'){ lang = 'de'; }
      state.selectedLanguage = lang;

      if (lang == 'en')
          locale.use(enLocale);
      else
          locale.use(deLocale);
   },
   // retrieving translations from server socket event
   SOCKET_translation: ({ commit }, data) => {
      if(!state.selectedLanguage){ state.selectedLanguage = 'de' }
      let translations = {};
      for(var i = 0; i < data.obj.length; i++) {
         translations[data.obj[i]['key']] = data.obj[i][state.selectedLanguage];
         //translations[tr[i][Object.keys(tr[i])[0]]] = tr[i][Object.keys(tr[i])[1]];
      }
      state.translations = translations;
   },
   // check retrieving translations from MIXIN GET !!! is it needed ???
   'SET_TRANSLATION': ({ commit }, data) => {
      if(!state.selectedLanguage){ state.selectedLanguage = 'de' }
      let translations = {};
      for(var i = 0; i < data.obj.length; i++) {
         translations[data.obj[i]['key']] = data.obj[i][state.selectedLanguage];
      }
      state.translations = translations;
   }
};

const actions = {
   setLanguage: ({commit}, lang) => {
      commit('SET_LANGUAGE', lang);
   }
};

const getters= {
    getTranslations: (state) => {
       return state.translations;
    },
    getDefaultTranslations: (state) => {
       return state.defaultTranslations;
    },
    getLanguage: (state) => {
      return state.selectedLanguage;
    }
};

export default {
   state,
   mutations,
   actions,
   getters
};


// WEBPACK FOOTER //
// ./src/Banet/store/modules/translations.js